const resetPassInputs = [
  {
    label: 'New password',
    name: 'new_password'
  }
];

export default resetPassInputs;
